const ForwardArrow = ({ height = "22", width = "22", color = "#040721" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.4955 9.76799L9.74361 5.01613L10.9964 3.76331L17.887 10.6539L10.9964 17.5443L9.74361 16.2915L14.4955 11.5398H3.71289V9.76799H14.4955Z"
        fill={color}
      />
    </svg>
  );
};
export default ForwardArrow;
